export function setupSideMenuLocale(scope: ParentNode = document): void {
  scope
    .querySelectorAll<HTMLElement>("[data-side-menu-locale]")
    .forEach((root) => {
      const toggle = root.querySelector<HTMLButtonElement>(
        "[data-side-menu-locale-toggle]",
      );
      const list = root.querySelector<HTMLElement>(
        "[data-side-menu-locale-list]",
      );
      const input = root.querySelector<HTMLInputElement>(
        "[data-side-menu-locale-input]",
      );
      if (!toggle || !list) return;

      const close = () => {
        list.classList.remove("is-visible");
        toggle.setAttribute("aria-expanded", "false");
      };

      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!expanded));
        list.classList.toggle("is-visible", !expanded);
      });

      root
        .querySelectorAll<HTMLElement>("[data-side-menu-locale-option]")
        .forEach((option) => {
          option.addEventListener("click", (e) => {
            e.preventDefault();
            const value = option.dataset.value;
            if (!value || !input) return;
            input.value = value;
            const form = root.closest("form");
            form?.submit();
          });
        });

      document.addEventListener("click", (e) => {
        if (!list.classList.contains("is-visible")) return;
        if (root.contains(e.target as Node)) return;
        close();
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && list.classList.contains("is-visible")) {
          close();
          toggle.focus();
        }
      });
    });
}
